<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
      @row-click="selectCurrentRow"
    >
      <el-form-item label="课程分组名称">
        <el-input v-model="filters.Name" placeholder="请输入课程分组名称"></el-input>
      </el-form-item>
      <el-form-item label="上级分组名称">
        <el-input v-model="filters.ParentName" placeholder="请输入上级分组名称"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="正常" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>
     
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button> 
      </el-form-item>
    </el-form>
    <!--列表-->
    <!-- <el-button type="primary" v-if="PL_IF" @click="batchPass" :disabled="this.sels.length===0">批量审批</el-button> -->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column
        prop="Name"
        label="课程分组名称"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="ParentName"
        label="上级分组名称"
        width
        sortable
      ></el-table-column>
    <el-table-column
        prop="Status"
        label="状态"
        :formatter="formatStatus"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建日期"
        :formatter="formatDateTime"
        width
        sortable
      ></el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-link type="primary" @click="handleOpen(scope.row.Id)">
            详情
          </el-link> | 
          <el-link
            type="primary"
            @click="handleEdit(scope.row.Id)"
          >
            编辑
          </el-link>
            <span v-if="scope.row.Type==1?true:false"> | </span> 
          <el-link  v-if="scope.row.Type==1?true:false"
            type="primary"
            @click="handleDetailOpen(scope.row.Id)"
          >
            查看签到码
          </el-link> 
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <el-dialog
      :title="dialog_title"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :before-close="editForm_close"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="180px"
        :rules="editFormRules"
        ref="editForm"
      >
       <el-row>
          <el-col :span="12">
            <el-form-item label="课程分组名称" prop="Name">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Name"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级分组" prop="ParentId">
              <el-select
                :disabled="DETAIS_IF"
                v-model="editForm.ParentId"
                filterable
                placeholder="请选择"
                :filter-method="ParentId_change"
                style="width: 100%"
              >
                <el-option
                  v-for="item in ParentCurriculumGroup_list"
                  :key="item.Value"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select
                v-model="editForm.Status"
                :disabled="DETAIS_IF"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Reamrk">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Reamrk"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col> 
        </el-row>
     
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_close">取消</el-button>
        <el-button
          v-if="!DETAIS_IF"
          type="primary"
          @click.native="editSubmit('editForm')"
          :loading="editLoading"
        >
          确认
        </el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetCurriculumGroupList,
  AddCurriculumGroup,
  UptCurriculumGroup,
  GetCurriculumGroup,
  GetCurriculumGroupSelectList,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      ParentCurriculumGroup_list: [],
      fileList: [],
      token: {},
      DETAIS_IF: true,
      READ: true,
      READ_IF: true,
      isShowHide:false,
      couponId:0,
      dialog_title: "",
      detailFormVisible: false,
      detailForm: {
      },
      editLoading: false,
      editForm: {
        // ClassDate: "",
        // ClassStartTimeKey: "",
      },
      editFormRules: {
        Name: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        Status: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      editFormVisible: false,
      editFormVisible_class: false,
      editFormVisible_jl: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      PL_IF: true,
      filters: {
        Name: "",
        ParentName:"",
        Status: -1
      },
      users: [],
      users_dialog: [],
      users_dialog_jl: [],
      total: 0,
      total_dialog: 0,
      page: 1,
      page_dialog: 1,
      page_dialog_jl: 1,
      listLoading: false,
      sels: [], //列表选中列
    };
  },
  methods: {
    selsChange: function (value) {
      this.sels = value;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    getModules_search() {
      this.page = 1;
      this.getModules();
    },
    async editSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            if (this.editForm.ParentId == null) {
              this.editForm.ParentId = 0;
            }
            let data;
            if (this.dialog_title == "新增") {
              data = await AddCurriculumGroup(this.editForm);
            } else {
              data = await UptCurriculumGroup(this.editForm);
            }
            if (data.data.success) {
              this.editFormVisible = false;
              this.$message({
                message: data.data.msg,
                type: "success",
              });
              this.getModules_search();
              this.editForm = {};
            }
            else
            {
              this.editFormVisible = false;
              this.$message({
                message: data.data.msg,
                type: "error",
              });
              this.getModules_search();
              this.editForm = {};
            }
          } else {
            return false;
          }
        });
      },
    handleAdd() {
      this.ParentId_GetList_fn();
      this.editFormVisible = true;
      this.dialog_title = "新增";
      this.DETAIS_IF = false;
    },
    editForm_close() {
      this.editFormVisible = false;
      this.editForm = {};
    },
    async details_GetCurriculumGroup(ids) {
      const { data } = await GetCurriculumGroup({
        id: ids,
      });
      this.editForm = data.response;
      if( data.response.ParentId==0)
      {
        this.editForm.ParentId=null;
      }
      this.editFormVisible = true;
      
    },
    detailForm_close() {
      this.detailFormVisible = false;
      this.detailForm = {};
    },
    
    // 查看
    async handleOpen(ids) {
      await this.ParentId_GetList_fn();
      this.details_GetCurriculumGroup(ids);
      this.DETAIS_IF = true;
      this.READ = true;
      this.READ_IF = true;
      // this.editFormVisible = true;
      this.dialog_title = "查看";
    },
    async handleEdit(ids) {
      await this.ParentId_GetList_fn();
      this.details_GetCurriculumGroup(ids);
      // this.editFormVisible = true;
      this.dialog_title = "编辑";
      this.DETAIS_IF = false;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
      //此处根据选中的券，判断是否符合导入
      let row = this.currentRow;
    },
    callFunc(item) {
      this[item.Func].apply(this, item);
    },
    ParentId_change(e) {
      this.ParentId_GetList_fn(e);
    },
    async ParentId_GetList_fn(e) {
      const { data } = await GetCurriculumGroupSelectList({
        name: e,
      });
      this.ParentCurriculumGroup_list = data.response;
    },
    //日期显示转换
    formatDateTime: function (row, column) {
      let data = row[column.property]
      if (data == null) {
        return null
      }else {
        return util.formatDate.format(new Date(data), "yyyy-MM-dd");
      }
    },
    formatStatus: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return "正常"
      }else if (data == 0){
        return "禁用";
      }else {
        return null
      }
    },
    formatType: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return "线下培训"
      }else if (data == 0){
        return "线上培训";
      }else {
        return null
      }
    },
    //获取用户列表
    getModules() {
      let para = this.filters;
      para.page = this.page;
      this.listLoading = true;
      GetCurriculumGroupList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel(ids) {
      // console.log(ids);
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          ClassScheduleDelete({
            id: ids,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    // let roleNames = JSON.parse(localStorage.getItem("roleNames"));
    this.getModules();
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: "Bearer " + tokenStr,
    };
    console.log(this.token);
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 320px !important;
  height: 180px !important;
  display: block;
}
</style>
<style>
.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
/* 
  .el-link.el-link--primary:hover {
    color: #409eff !important;
  } */

.el-link.el-link {
  color: #409eff !important;
}
.el-link.is-underline:hover:after {
  border-bottom: 1px solid #409eff !important;
}
.el-link.el-link--default:after,
.el-link.el-link--primary.is-underline:hover:after,
.el-link.el-link--primary:after {
  border-color: #409eff !important;
}
.el-pager li.active {
  color: #409eff !important;
}
</style>
